// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CameraCameraOffComponent} from './CameraCameraOff.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCameraCameraOff = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CameraCameraOffComponent/>
  </Icon>
));
